// components/NavBar.jsx
import React from "react";
import { FaBell } from "react-icons/fa";
import { NavLink, Outlet } from "react-router-dom";
import logo from "../../../assets/Icons/QuesthireBlack1.png";
import { CgMenuRound } from "react-icons/cg";

const NavBar = () => {
  return (
    <>
      <nav className="w-full px-6 sm:px-10 lg:px-24  border-b flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-0">
        {/* Left: Logo */}
        <div className="flex items-center gap-2">
          <img src={logo} alt="Logo" className="w-60 absolute left-2" />
        </div>

        {/* Middle: Search Bar */}
        <div className="flex-1 w-full max-w-[36rem] sm:mx-4 relative">
          <input
            type="text"
            placeholder="Search job title and location"
            className="w-full border border-gray-300 rounded-md px-7 py-[0.7rem] pr-28 text-sm focus:outline-none focus:ring-2 focus:ring-black"
          />
          <button className="absolute right-1 top-1 bottom-1 hover:bg-[#004349] bg-black text-white px-6 rounded-md font-semibold text-sm">
            Search
          </button>
        </div>

        {/* Right: Menu */}
        <div className="flex   h-[4rem] font-medium">
          <NavLink
            to="/jobseeker/home"
            className={({ isActive }) =>
              isActive
                ? "text-black flex items-center border-b-4 px-6 border-black "
                : "text-gray-600 flex items-center hover:text-black px-6"
            }
          >
            <span>Home</span>
          </NavLink>
          <NavLink
            to="/jobseeker/my-jobs"
            className={({ isActive }) =>
              isActive
                ? "text-black border-b-4 flex items-center px-6 border-black "
                : "text-gray-600 flex items-center hover:text-black px-6"
            }
          >
            <span>My Jobs</span>
          </NavLink>
          <NavLink
            to="/jobseeker/messages"
            className={({ isActive }) =>
              isActive
                ? "text-black flex items-center border-b-4 px-6 border-black "
                : "text-gray-600 flex items-center hover:text-black px-6"
            }
          >
            <span>Messages</span>
          </NavLink>
          <NavLink
            to="/jobseeker/profile"
            className={({ isActive }) =>
              isActive
                ? "text-black flex items-center border-b-4 px-6 border-black "
                : "text-gray-600 flex items-center hover:text-black px-6"
            }
          >
            <span>Profile</span>
          </NavLink>
          <span className="text-gray-500 flex items-center px-6 text-lg">
            <FaBell />
          </span>
          <span className="text-gray-500 flex items-center px-6 text-lg">
            <CgMenuRound />
          </span>
        </div>
      </nav>
      <Outlet />
    </>
  );
};

export default NavBar;
